'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import get from 'lodash.get';

import styles from './Header.scss';

function Header({item}) {
    const dealerLocation = get(item, 'seller.shippingAddress.displayCityStateCountry');
    return (
        <div className={`rowFlex colSm12 ${styles.container}`}>
            {`ships from ${dealerLocation}`}
        </div>
    );
}

Header.propTypes = {
    item: PropTypes.object
};

export default Relay.createContainer(Header, {
    fragments: {
        item: () => Relay.QL`
            fragment on Item {
                seller {
                    shippingAddress {
                        displayCityStateCountry
                    }
                }
            }
        `
    }
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/ShippingDetailsModal/Header.jsx